// Composable for opening the create DomainTerm dialog.
import { useDialog } from "primevue/usedialog";
import { defineAsyncComponent } from "vue";

export const useEditDomainTermDialog = () => {
    const dialog = useDialog();

    const open = () => {
        dialog.open(
            defineAsyncComponent(
                () => import("@/components/DomainTerms/NewDomainTerm.vue")
            ),
            {
                props: {
                    header: "Add term",
                    modal: true,
                    style: { width: "35rem" },
                },
            }
        );
    };

    return { open };
};
